import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    color: 'white',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const RoleDropdown = ({ getRole, modalInfo }) => {
    const [roleSelect, setRoleSelect] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getRoles = async () => {
            const roleFromServer = await fetchRole();
            setRoleSelect(roleFromServer);
        };

        if (modalInfo) {
            const role = {
                value: modalInfo.roleID,
                label: modalInfo.roleName,
            };
            setSelectedOption(role)
        }

        getRoles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalInfo]);

    // Fetch Categories
    const fetchRole = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/grievance/getfactoryAndCategorylist'
        );
        const data = await res.json();

        return data.grievanceRoleList;
    };

    const options = roleSelect.map((role, index) => {
        return {
            value: role.id,
            label: role.name
        }
    })

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);

        if (selectedOption) {
            getRole(selectedOption.value)
        }
    };

    return (
        <Select
            placeholder={'Select a role...'}
            components={{ Control: ControlComponent }}
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isClearable
        />
    );
};

export default RoleDropdown;
